import { AppLayout } from "../shared";
import MasterOrgDashboard from "../MasterOrg/DashboardHome";

const MasterOrgDashboard_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <MasterOrgDashboard props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default MasterOrgDashboard_layout;
